// Cookie consent helpers — RGPD / LPD compliant.
//
// Storage key holds an object:
//   { essential: true, analytics: bool, marketing: bool, decided_at: ISO }
// If the key is absent the user has NOT decided yet → banner must be shown.

export const CONSENT_STORAGE_KEY = "capitalauto_cookie_consent";
export const CONSENT_CHANGED_EVENT = "capitalauto-consent-changed";

const DEFAULT_DENIED = {
    essential: true,
    analytics: false,
    marketing: false,
};

export function readConsent() {
    if (typeof window === "undefined") return null;
    try {
        const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return {
            essential: true,
            analytics: !!parsed.analytics,
            marketing: !!parsed.marketing,
            decided_at: parsed.decided_at || null,
        };
    } catch (_) {
        return null;
    }
}

export function hasDecided() {
    return readConsent() !== null;
}

export function writeConsent({ analytics, marketing }) {
    if (typeof window === "undefined") return;
    const value = {
        essential: true,
        analytics: !!analytics,
        marketing: !!marketing,
        decided_at: new Date().toISOString(),
    };
    try {
        window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(value));
    } catch (_) {
        // ignore quota errors
    }
    // Notify the GoogleTags / tracking layer to (re)apply consent.
    try {
        window.dispatchEvent(
            new CustomEvent(CONSENT_CHANGED_EVENT, { detail: value }),
        );
    } catch (_) {
        // ignore
    }
    return value;
}

export function acceptAll() {
    return writeConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
    return writeConsent({ analytics: false, marketing: false });
}

/** Effective consent (denied defaults if no decision yet). */
export function effectiveConsent() {
    return readConsent() || DEFAULT_DENIED;
}
